import { Button, Modal } from '@sequencehq/core-components'
import { modalScreenAtom } from '../../atoms/screens.atom'
import { useAtom } from 'jotai'
import { Flex } from '@chakra-ui/react'
import Spinner from 'components/Loading'
import { GreyWhite } from '@sequencehq/design-tokens'

export const Footer = (props: {
  onContinue: () => void
  onBack?: () => void
  destructive?: boolean
  submitButtonText?: string
  disabled?: boolean
  submitting?: boolean
}) => {
  const [, setModalScreen] = useAtom(modalScreenAtom)
  const submitDisabled = props.disabled || props.submitting

  return (
    <Modal.Footer withBorder>
      <Flex justifyContent="flex-end" width="100%" gap="8px">
        <Button
          variant="secondary"
          onClick={props.onBack || (() => setModalScreen('selection'))}
        >
          Back
        </Button>
        <Button
          variant={props.destructive ? 'destructive' : 'primary'}
          onClick={() => !submitDisabled && props.onContinue()}
          disabled={submitDisabled}
        >
          <Flex gap="8px">
            {props.submitting && (
              <Spinner height="16px" width="16px" color={GreyWhite} />
            )}
            {props.submitButtonText ?? 'Continue'}
          </Flex>
        </Button>
      </Flex>
    </Modal.Footer>
  )
}
